export const FEATURE_FLAGS = {
  OPERATIONAL_MEDPREV_WEB_APP_LEVEL_TWO: 'operational-medprev-web-app-level-two',
  OPERATIONAL_MEDPREV_WEB_APP_SWITCH_FLEX_TO_WHATSAPP: 'operational-medprev-web-app-switch-flex-to-whatsapp',
} as const;

export type FeatureFlagKey = typeof FEATURE_FLAGS[keyof typeof FEATURE_FLAGS];

export const FEATURE_FLAG_DEFAULTS: Record<FeatureFlagKey, boolean> = {
  [FEATURE_FLAGS.OPERATIONAL_MEDPREV_WEB_APP_LEVEL_TWO]: false,
  [FEATURE_FLAGS.OPERATIONAL_MEDPREV_WEB_APP_SWITCH_FLEX_TO_WHATSAPP]: false,
} as const;
